<div class="tw-inline-flex tw-min-w-0 tw-w-full tw-max-w-full tw-items-center tw-gap-0.5">
  @if (computedIcon()) {
    <bit-icon [name]="computedIcon()" [class]="iconSizeStyles()" />
  }

  <span [class]="contentClasses()">
    <ng-content></ng-content>
  </span>
</div>
